/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Artist coin fee info (unclaimed/total)
 * @export
 * @interface ArtistCoinFees
 */
export interface ArtistCoinFees {
    /**
     * Unclaimed fees
     * @type {number}
     * @memberof ArtistCoinFees
     */
    unclaimedFees?: number;
    /**
     * Total fees
     * @type {number}
     * @memberof ArtistCoinFees
     */
    totalFees?: number;
}

/**
 * Check if a given object implements the ArtistCoinFees interface.
 */
export function instanceOfArtistCoinFees(value: object): value is ArtistCoinFees {
    let isInstance = true;

    return isInstance;
}

export function ArtistCoinFeesFromJSON(json: any): ArtistCoinFees {
    return ArtistCoinFeesFromJSONTyped(json, false);
}

export function ArtistCoinFeesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistCoinFees {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unclaimedFees': !exists(json, 'unclaimed_fees') ? undefined : json['unclaimed_fees'],
        'totalFees': !exists(json, 'total_fees') ? undefined : json['total_fees'],
    };
}

export function ArtistCoinFeesToJSON(value?: ArtistCoinFees | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unclaimed_fees': value.unclaimedFees,
        'total_fees': value.totalFees,
    };
}

